import React, { useState } from "react";
import Card from "react-bootstrap/Card";
import "./teamgenerator.css";
import { Form, Button } from "react-bootstrap/";
import { shuffle } from "../helper";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import logo from "../../img/logo.jpg";

const TeamGenerator = (props) => {
  const [noOfTeams, setNoOfTeams] = useState();
  const [teams, setTeams] = useState([]);

  const handleChange = (e) => {
    const value = parseInt(e.target.value, 10);
    if (value > 0) {
      setNoOfTeams(value);
    } else {
      setNoOfTeams("");
    }
  };

  const handleGenerateBtnClick = () => {
    const shuffledArray = shuffle(props.list);
    if (!noOfTeams || noOfTeams < 1) {
      setTeams([]);
    } else {
      const noOfPeoplePerTeam = Math.ceil(shuffledArray.length / noOfTeams);
      const res = [];
      for (let i = 0; i < noOfTeams; i++) {
        res.push(shuffledArray.slice(i * noOfPeoplePerTeam, (i + 1) * noOfPeoplePerTeam));
      }
      setTeams(res);
    }
  };

  const handleDownloadPdf = () => {
    const input = document.getElementById("teams-container");
    html2canvas(input, { scale: 3 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      // Calculate position to center the card images horizontally
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const cardWidth = 120; // Width of each card image in mm

      const x = (pdfWidth - cardWidth) / 2;
      let y = 10; // Start at the top of the page

      // Add title above the cards
      pdf.setFontSize(16);
      pdf.text("TEAMS:", pdfWidth / 2, y, { align: "center" });

      // Calculate new position after adding the title
      y += 10; // Move down a bit

      // Add each card image
      pdf.addImage(imgData, "PNG", x, y, cardWidth, (canvas.height * cardWidth) / canvas.width);

      // Save the PDF
      pdf.save("teams.pdf");
    });
  };

  return (
    <Form.Group className="mb-3 random-container" controlId="exampleForm.ControlInput1">
      <Form.Label>How many teams?</Form.Label>
      <div className="input-button-wrapper">
        <Form.Control
          classname="input-teams"
          type="number"
          placeholder=""
          value={noOfTeams || ""}
          onChange={handleChange}
        />
        <Button
          onClick={handleGenerateBtnClick}
          variant="primary"
          className="pick-button generator-btn"
        >
          Generate
        </Button>
        {teams.length > 0 && (
          <Button onClick={handleDownloadPdf} className="download-pdf-btn pick-button ">
            Download
          </Button>
        )}
      </div>

      <div id="teams-container" className="cards-container">
        {teams
          .filter((team) => team.length > 0)
          .map((team, teamIndex) => (
            <Card
              text="blue"
              style={{ width: "18rem", marginTop: "1rem", marginRight: "1rem" }}
              key={teamIndex}
              className="cardz"
            >
              <Card.Header>Team {teamIndex + 1}</Card.Header>
              <Card.Body>
                <Card.Title></Card.Title>
                <Card.Text>
                  <ol className="numbered-list">
                    {team.map((member, memberIndex) => {
                      const capitalizedMember = member
                        .split(" ")
                        .map((namePart) => namePart.charAt(0).toUpperCase() + namePart.slice(1))
                        .join(" ");
                      return <li key={memberIndex}>{capitalizedMember}</li>;
                    })}
                  </ol>
                </Card.Text>
              </Card.Body>
            </Card>
          ))}
      </div>
    </Form.Group>
  );
};

export default TeamGenerator;
